import { Component, AfterViewInit, OnInit, ViewChild } from '@angular/core';
import { MainService } from '../../service/main.service';
import { AuthenticationService } from '../../../authentication.service';
import { ProfileService } from '../../service/profile.service';
import { Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { ComplaintWorkflowService } from '../../service/complaint-workflow.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { session } from '../../../../environments/environment.session'
import { Utf8EncodingService } from 'src/app/md/service/utf8-encoding.service';
@Component({
  selector: '[app-portal-header]',
  templateUrl: './portal-header.component.html',
  styleUrls: ['./portal-header.component.css']
})
export class PortalHeaderComponent implements AfterViewInit {

  imgURL: any;
  erpUser: any;
  userInfo: any = { first_name: 'UNKNOWN', designation: 'Accountant' }
  constructor(public auth: AuthenticationService,private utf8EncodingService:Utf8EncodingService, private complaintworkflowService: ComplaintWorkflowService,
    private router: Router, private profileService: ProfileService, private sanitizer: DomSanitizer,
    public mainService: MainService) {
    try {
      this.erpUser = this.utf8EncodingService.decodeFromUtf8((session['erpUser'] as any ));;
    } catch (error) {
      if (sessionStorage.getItem('1001') == undefined || sessionStorage.getItem('1001') == null) {
        this.router.navigate(['/login']);
      }
    }

  }
  hidden = true;
  accInfo = {}
  b_acct_id: any;
  totalForward: any;
  action = [
    { id: 1, name: 'Profile', route: "profile" },
    { id: 2, name: 'Account', route: "acc" },
    { id: 3, name: 'Logout', route: "login" },

  ];
  @ViewChild('ngSelectElement') ngSelectElement!: NgSelectComponent;
  selectedAction: any;
  placeholderText: any;
  isDropdownOpen: any = false;
  async ngOnInit() {
    // this.erpUser = Jthis.utf8EncodingService.decodeFromUtf8((session['erpUser'] as any ));;
    this.b_acct_id = this.erpUser?.b_acct_id;
    if (this.b_acct_id) {
      var dd = [];
      dd = this.erpUser?.role_cd
      if (dd.includes("AA")) {
        this.hidden = false;
      } else {
        this.hidden = true
      }



      await this.mainService.getUserImage(this.erpUser['user_id']);
      await this.mainService.getAccImage(this.erpUser['b_acct_id']);
      await this.mainService.getAccountInfo(this.erpUser['b_acct_id']);
      await this.changeLanguage();
      await this.getCount();
      await this.mainService.getMessageCount(this.erpUser['b_acct_id'], this.erpUser['user_id'])
    }
  }



  async getCount() {
    let obj: any = new Object();
    obj['b_acct_id'] = this.b_acct_id;
    obj['user_id_to'] = this.erpUser.user_id;
    var resp = await this.complaintworkflowService.getCount(JSON.stringify(obj));
    if (resp['error'] == false) {

      this.totalForward = resp.data[0]['counter'];

    } else {

    }
  }
  async changeLanguage() {
    this.mainService.language_cd = this.auth.language_cd
    this.mainService.allLanguage = this.auth.allLanguage
  }

  home() {
    this.router.navigate(['/index'])
  }
  ngAfterViewInit() {
  }


  async getCodeValue() {
    var resp = await this.mainService.getCodeValue(this.b_acct_id);
    var codeValueTempObj: any = {}
    var codeValueShowTempObj: any = {};
    if (resp['error'] == false) {
      for (var i = 0; i < resp.data.length; i++) {
        if (codeValueTempObj[resp.data[i]['field_code']] == undefined) {
          codeValueTempObj[resp.data[i]['field_code']] = [];
          codeValueShowTempObj[resp.data[i]['field_code']] = {}
        }
        codeValueShowTempObj[resp.data[i]['field_code']][resp.data[i].code] = resp.data[i].value;
        codeValueTempObj[resp.data[i]['field_code']].push(resp.data[i])
      }
      this.mainService.codeValueTechObj = codeValueTempObj;
      this.mainService.codeValueShowObj = codeValueShowTempObj;

    } else {

    }

  }
























  // async getUserImage() {
  //   const res = await this.profileService.getImage(this.user_id);
  //   console.log(res)

  //   if (res) {
  //     const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
  //     this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
  //     this.mainService.profileImageUrl = this.imgURL;
  //   }
  // }


  // async getUserInfo(){
  //   var resp= await this.profileService.getUserProfileInfo(this.user_id);
  //   console.log(resp);
  //   if(resp['error']==false){
  //     this.userInfo=resp.data[0];
  //     var erp=this.erpUser;
  //     erp['User_name']=this.userInfo['first_name']+" "+this.userInfo['last_name'];
  //     sessionStorage.setItem('erpUser',btoa(JSON.stringify(erp)));

  //     // console.log(this.userInfo)
  //   }else{

  //   }
  // }

  // async getAccImage() {
  //   const res = await this.profileService.getAccImage(this.erpUser.b_acct_id);
  //   if (res) {
  //     const unsafeImageUrl = window.URL.createObjectURL(res); // URL.createObjectURL(res);
  //     this.imgURL = this.sanitizer.bypassSecurityTrustUrl(unsafeImageUrl);
  //     this.mainService.accountImageUrl = this.imgURL;

  //   }
  // }
  // async getAccInfo() {
  //   var resp = await this.profileService.getAccProfileInfo(this.erpUser.b_acct_id);
  //   console.log(resp);
  //   if (resp['error'] == false) {
  //     this.accInfo = resp.data[0];
  //     this.mainService.accInfo = this.accInfo;
  //   } else {

  //   }

  // }

}


